import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
    visibleAssetsMarkersSelector,
} from '../../features/assets/assetsSlice';
import { mapServiceSelector } from '../../features/map/mapSlice';


import GoogleVehicleIcon from './google/GoogleVehicleIcon';
import GoogleTailPath from './google/GoogleTailPath';

import OsmVehicleIcon from './osm/OsmVehicleIcon';
import OsmTailPath from './osm/OsmTailPath';

const GoogleVehicleOverlay = () => {

    const visibleAssetMarkers = useSelector(visibleAssetsMarkersSelector);
    const mapService = useSelector(mapServiceSelector);

    const plotLiveIcons = useCallback(
        () => {
            return visibleAssetMarkers.map(assetId => (
                mapService === 'google' ?
                    <GoogleVehicleIcon
                        key={`icon_${assetId}`}
                        assetId={assetId}
                    />
                    :
                    <OsmVehicleIcon
                        key={`icon_${assetId}`}
                        assetId={assetId}
                    />
            ));
        },
        [visibleAssetMarkers, mapService],
    );

    const plotTails = useCallback(
        () => {
            return visibleAssetMarkers.map(assetId => {
                return (
                    mapService === 'google' ?
                        <GoogleTailPath
                            assetId={assetId}
                            key={`tail_${assetId}`}
                        />
                        :
                        <OsmTailPath
                            assetId={assetId}
                            key={`tail_${assetId}`}
                        />
                );
            })
        },
        [visibleAssetMarkers, mapService],
    );

    const comboIcons = useCallback(
        () => {
            const icons = plotLiveIcons();
            const tails = plotTails();
            return [...icons, ...tails];
        },
        [plotLiveIcons, plotTails],
    );

    return (
        <div>
            {comboIcons()}
        </div>
    );

}

export default GoogleVehicleOverlay;

/*const plotLiveIcon = () => {
        //console.log("Plot icons", visibleAssetMarkers.length);
        visibleAssetMarkers.forEach(assetId => {
            setVehicleIcons({
                ...vehicleIcons,
                [`${assetId}`]: <VehicleIcon
                    key={`icon_${assetId}`}
                    assetId={assetId}
                />
            })
        })
    }

    const plotTail = () => {
        visibleAssetMarkers.forEach(assetId => {
            setvehicleTails({
                ...vehicleTails,
                [`${assetId}`]: <TailPath
                    assetId={assetId}
                    key={`tail_${assetId}`}
                />
            })
        })
    }*/